module.exports = __webpack_public_path__ + "img/f7dbb2b.png";